var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconLink',{attrs:{"href":_vm.supportFormURL,"target":_vm.target,"rel":_vm.rel}},[_vm._v("\n  "+_vm._s(_vm.hyperlinkText)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }